import { styled } from "styled-components";

export const PricingClassWrapper = styled.div`
  padding: 80px 0 60px;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0 7.813vw;
  }
`;

export const PricingClassNavList = styled.ul`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  position: fixed;
  top: 100px;
  left: 0;
  width: 100%;
  background-color: #fbfbfb;
  z-index: 1;
  li {
    font-size: 24px;
    line-height: 1.3;
    font-weight: bold;
    cursor: pointer;
    color: #c1c1c1;
    &.active {
      color: #171717;
    }
  }
  @media all and (max-width: 1024px) {
    top: 80px;
  }
  @media all and (max-width: 768px) {
    top: 60px;
    gap: 5.208vw;
    height: 10.417vw;
    li {
      font-size: 3.385vw;
    }
  }
`;

export const PricingClassWrap = styled.div`
  .title-area {
    display: flex;
    flex-direction: column;
    gap: 24px;
    h6 {
      font-family: "AnekLatin-semibold";
      font-weight: 600;
      font-size: 72px;
      color: #171717;
    }
    p {
      font-size: 24px;
      line-height: 1.3;
      color: #242424;
    }
    & + div {
      flex: 1;
    }
  }
  @media all and (max-width: 768px) {
    .title-area {
      gap: 2.344vw;
      h6 {
        font-size: 7.813vw;
      }
      p {
        font-size: 4.167vw;
      }
    }
  }
`;

export const PricingWrap = styled.div`
  display: flex;
  gap: 80px;
  padding: 60px 0;
  @media all and (max-width: 1024px) {
    flex-direction: column;
  }
  @media all and (max-width: 768px) {
    gap: 5.208vw;
    padding: 6.51vw 0;
  }
`;

export const ClassWrap = styled.div`
  display: flex;
  gap: 80px;
  padding: 60px 0;
  @media all and (max-width: 1024px) {
    flex-direction: column;
  }
  @media all and (max-width: 768px) {
    gap: 5.208vw;
    padding: 6.51vw 0;
  }
`;

export const PricingListWrap = styled.ul`
  width: 100%;

  > p {
    font-size: 14px;
    line-height: 1.5;
    color: #6f6f6f;
    br {
      &.mobile {
        display: none;
      }
    }
    &:first-of-type {
      margin-top: 16px;
    }
  }
  > li {
    &:not(:first-of-type) {
      margin-top: 40px;
    }
    dl {
      border: 1px solid #dfdfdf;
      border-radius: 8px;
      overflow: hidden;
      width: 100%;
      dt {
        color: #fbfbfb;
        padding: 8px 16px;
        font-weight: bold;
        font-size: 24px;
        line-height: 1.3;
        &.grey {
          background-color: #555555;
        }
        &.black {
          background-color: #171717;
        }
      }
      > div {
        padding: 32px 40px;

        &:not(:last-child) {
          border-bottom: 1px solid #dfdfdf;
        }
        .sub-text {
          margin-top: 20px;
          font-weight: bold;
          color: #171717;
          font-size: 16px;
        }
        > div {
          display: flex;
          align-items: center;
          gap: 16px;
          > p {
            color: #242424;
            font-weight: bold;
            font-size: 20px;
            line-height: 1.4;
            max-width: 220px;
            min-width: 220px;
          }
        }
      }
      ul {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 16px;
        > li {
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: space-between;
          > div {
            width: calc(100% - 190px);
            > p {
              color: #6f6f6f;
              font-weight: bold;
              font-size: 16px;
              line-height: 1.5;
            }
          }
          > span {
            display: block;
            width: 190px;
            text-align: left;
            font-weight: bold;
            color: #171717;
            font-size: 16px;
            line-height: 1.5;
          }
        }
      }
    }
  }
  @media all and (max-width: 1200px) {
    > li {
      dl {
        > div {
          > div {
            > p {
              max-width: 200px;
              min-width: 200px;
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    > p {
      font-size: 3.125vw;
      word-break: keep-all;
      &:first-of-type {
        margin-top: 3.646vw;
      }
      br {
        &.mobile {
          display: block;
        }
      }
    }
    > li {
      &:not(:first-of-type) {
        margin-top: 7.813vw;
      }
      dl {
        border-radius: 1.563vw;
        dt {
          padding: 2.083vw 3.125vw;
          font-size: 4.167vw;
        }
        > div {
          padding: 5.208vw 6.25vw;

          .sub-text {
            margin-top: 4.167vw;
            font-size: 3.385vw;
          }
          > div {
            gap: 3.125vw;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            > p {
              min-width: 100%;
              max-width: 100%;
              font-size: 3.906vw;
              gap: 5.208vw;
            }
          }
        }
        ul {
          gap: 3.125vw;
          width: 100%;
          > li {
            width: 100%;
            display: flex;
            justify-content: space-between;
            > div {
              width: 100%;
              > p {
                font-size: 3.646vw;
              }
            }
            > span {
              min-width: 41.667vw;
              font-size: 3.646vw;
              text-align: right;
            }
          }
        }
      }
    }
  }
`;

export const FreepassListWrap = styled.ul`
  width: 100%;

  > p {
    font-size: 14px;
    line-height: 1.5;
    color: #6f6f6f;
    br {
      &.mobile {
        display: none;
      }
    }
    &:first-of-type {
      margin-top: 16px;
    }
  }
  > li {
    &:not(:first-of-type) {
      margin-top: 40px;
    }
    dl {
      border: 1px solid #dfdfdf;
      border-radius: 8px;
      overflow: hidden;
      width: 100%;
      dt {
        color: #fbfbfb;
        padding: 8px 16px;
        font-weight: bold;
        font-size: 24px;
        line-height: 1.3;
        &.grey {
          background-color: #555555;
        }
        &.black {
          background-color: #171717;
        }
      }
      .list-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
        > .list-wrap {
          flex: 1;
          border-right: 1px solid #dfdfdf;
          > div {
            padding: 32px 40px;

            &:not(:last-child) {
              border-bottom: 1px solid #dfdfdf;
            }
            .sub-text {
              margin-top: 20px;
              font-weight: bold;
              color: #171717;
              font-size: 16px;
            }
            > div {
              display: flex;
              align-items: center;
              gap: 16px;
              > p {
                color: #242424;
                font-weight: bold;
                font-size: 20px;
                line-height: 1.4;
                max-width: 220px;
                min-width: 220px;
              }
            }
          }
        }
        .price-text-wrap {
          width: 30%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          gap: 16px;
          > p {
            color: #242424;
            font-weight: bold;
            font-size: 24px;
            text-decoration: line-through;
          }
          > span {
            color: #242424;
            font-weight: bold;
            font-size: 18px;
          }
          .text-wrap {
            span {
              color: #6f6f6f;
              font-weight: bold;
              font-size: 16px;
            }
            h6 {
              color: #242424;
              font-weight: bold;
              font-size: 20px;
            }
          }
        }
      }
      ul {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 16px;
        > li {
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: space-between;
          > div {
            width: 100%;
            > p {
              color: #6f6f6f;
              font-weight: bold;
              font-size: 16px;
              line-height: 1.5;
            }
          }
          > span {
            display: block;
            width: 190px;
            text-align: left;
            font-weight: bold;
            color: #171717;
            font-size: 16px;
            line-height: 1.5;
          }
        }
      }
    }
  }
  .sale-wrap {
    margin-bottom: 16px;
    .sale-list-wrap {
      li {
        display: flex;
        flex-direction: column;
        padding: 24px 40px;
        gap: 6px;
        .text-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;
          > p {
            color: #242424;
            font-weight: bold;
            font-size: 18px;
            line-height: 1.4;
            &.red {
              color: red;
            }
            span {
              display: inline-block;
              margin-left: 5px;
              text-align: left;
              font-weight: bold;
              color: #6f6f6f;
              font-size: 16px;
            }
          }
          > span {
            color: #6f6f6f;
            font-weight: bold;
            font-size: 16px;
            line-height: 1.5;
            width: 190px;
            text-align: left;
          }
        }
        .info-msg {
          color: #242424;
          font-size: 14px;
          line-height: 1.2;
          color: #6f6f6f;
          text-align: left;
          width: 100%;
        }
      }
    }
  }
  @media all and (max-width: 1200px) {
    > li {
      dl {
        .list-wrapper {
          > .list-wrap {
            > div {
              > div {
                > p {
                  max-width: 200px;
                  min-width: 200px;
                }
              }
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    > p {
      font-size: 3.125vw;
      word-break: keep-all;
      &:first-of-type {
        margin-top: 3.646vw;
      }
      br {
        &.mobile {
          display: block;
        }
      }
    }
    > li {
      &:not(:first-of-type) {
        margin-top: 7.813vw;
      }
      dl {
        border-radius: 1.563vw;
        dt {
          padding: 2.083vw 3.125vw;
          font-size: 4.167vw;
        }
        .list-wrapper {
          .price-text-wrap {
            width: 40%;
            gap: 2.604vw;
            > p {
              font-size: 5.208vw;
            }
            > span {
              font-size: 3.646vw;
            }
            .text-wrap {
              span {
                font-size: 3.385vw;
              }
              h6 {
                font-size: 3.646vw;
              }
            }
          }
          > .list-wrap {
            height: auto;
            > div {
              padding: 5.208vw 6.25vw;
            }
            div {
              .sub-text {
                margin-top: 4.167vw;
                font-size: 3.385vw;
              }
              > div {
                gap: 3.125vw;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                > p {
                  font-size: 3.906vw;
                  gap: 5.208vw;
                }
              }
            }
          }
        }
        ul {
          gap: 3.125vw;
          width: 100%;
          > li {
            width: 100%;
            display: flex;
            justify-content: space-between;
            > div {
              width: 100%;
              > p {
                font-size: 3.646vw;
              }
            }
            > span {
              min-width: 41.667vw;
              font-size: 3.646vw;
              text-align: right;
            }
          }
        }
      }
    }
    .sale-wrap {
      margin-bottom: 3.646vw;
      .sale-list-wrap {
        li {
          padding: 5.208vw 6.25vw;
          .text-wrap {
            > p {
              font-size: 3.646vw;
              word-break: keep-all;

              span {
                margin-left: 1.302vw;
                font-size: 3.385vw;
              }
            }
            > span {
              font-size: 3.385vw;
            }
          }
          .info-msg {
            font-size: 3.125vw;
          }
        }
      }
    }
  }
`;

export const ClassListWrap = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  li {
    width: 100%;
    padding-top: 32px;
    border-top: 1px solid #171717;
    display: flex;
    flex-direction: column;
    gap: 32px;
    &.half {
      width: calc(50% - 20px);
    }
    > h6 {
      font-size: 38px;
      color: #171717;
      line-height: 1.3;
      font-weight: bold;
    }
    > div {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      dl {
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        &.half {
          width: calc(50% - 6px);
        }
        dt {
          color: #555;
          font-size: 16px;
          line-height: 1.5;
          font-weight: bold;
        }
        dd {
          color: #6f6f6f;
          font-size: 14px;
          line-height: 1.5;
        }
      }
    }
  }
  @media all and (max-width: 1200px) {
    li {
      &.half {
        width: 100%;
      }
      > h6 {
        br {
          display: none;
        }
      }
    }
  }
  @media all and (max-width: 1024px) {
    gap: 20px;
    li {
      &.half {
        width: calc(50% - 10px);
      }
      > h6 {
        br {
          display: block;
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    gap: 3.906vw;
    li {
      padding-top: 5.469vw;
      gap: 5.469vw;
      &.half {
        width: 100%;
      }
      > h6 {
        font-size: 5.729vw;
        word-break: keep-all;
        br {
          /* display: none; */
        }
      }
      > div {
        gap: 2.604vw;
        dl {
          gap: 1.823vw;
          &.half {
            width: 100%;
          }
          dt {
            font-size: 3.646vw;
          }
          dd {
            font-size: 3.385vw;
          }
        }
      }
    }
  }
`;
